import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const blogPosts = [
  {
    id: 1,
    slug: 'adanada-yuksekte-calisma-egitimi',
    category: 'İş Güvenliği',
    title: 'Adana\'da Yüksekte Çalışma Eğitimi: Güvenlik Önlemleri ve Sertifikasyon',
    excerpt: 'Adana Seyhan, Çukurova, Yüreğir ve Sarıçam ilçelerinde yüksekte çalışma güvenliği eğitimi, düşme önleme teknikleri ve İSG sertifikası alma rehberi.',
    content: 'Adana yüksekte çalışma eğitimi, inşaat, sanayi ve bakım sektörlerinde çalışan personel için hayati önem taşımaktadır. Adana\'da yüksekte çalışma kursu veren merkezimiz, 6331 sayılı İş Sağlığı ve Güvenliği Kanunu kapsamında zorunlu eğitimleri vermektedir.',
    image: 'https://public.readdy.ai/ai/img_res/8f8cb8db32efc22e3a62cb0d2acc5507.jpg',
    author: 'Ali Demir',
    date: '25 Ocak 2025',
    readTime: '9 dk'
  },
  {
    id: 2,
    slug: 'adana-mesleki-yeterlilik-egitimi-myk',
    category: 'MYK',
    title: 'Adana Mesleki Yeterlilik Eğitimi: MYK Belgesi ve Sertifika Programları 2025',
    excerpt: 'Adana\'da mesleki eğitim programları, MYK belgesi alma süreci, forklift operatörlüğü, vinç operatörlüğü ve iş makinesi operatörlüğü eğitimi hakkında detaylı bilgiler.',
    content: 'Adana mesleki eğitim merkezi olarak, Mesleki Yeterlilik Kurumu (MYK) onaylı sertifika programları sunuyoruz. Adana\'da MYK belgesi almak isteyen forklift operatörleri, vinç operatörleri ve iş makinesi operatörleri için kapsamlı eğitim programlarımız mevcuttur.',
    image: 'https://readdy.ai/api/search-image?query=Vocational%20training%20center%20in%20Adana%20Turkey%20with%20forklift%20operator%20training%20professional%20instructor%20teaching%20equipment%20operation%20modern%20warehouse%20facility%20with%20industrial%20equipment%20certification%20program&width=600&height=400&seq=adanamyk1&orientation=landscape',
    author: 'Mehmet Kaya',
    date: '24 Ocak 2025',
    readTime: '8 dk'
  },
  {
    id: 3,
    slug: 'adanada-hijyen-egitimi-gida-guveniligi',
    category: 'Hijyen',
    title: 'Adana\'da Hijyen Eğitimi: Gıda Güvenliği ve HACCP Sertifikası',
    excerpt: 'Adana gıda hijyeni eğitimi, HACCP sertifikası, restoran ve otel personeli için zorunlu hijyen kursu ve sağlık sertifikası alma süreci.',
    content: 'Adana hijyen eğitimi, gıda sektöründe çalışan tüm personel için yasal zorunluluktur. Adana\'da hijyen kursu veren merkezimiz, Sağlık Bakanlığı onaylı gıda güvenliği eğitimi ve HACCP sertifikası programları sunmaktadır.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20food%20hygiene%20training%20in%20Adana%20Turkey%20with%20chef%20and%20kitchen%20staff%20in%20white%20uniforms%20learning%20proper%20sanitation%20procedures%20clean%20modern%20commercial%20kitchen%20environment%20hand%20washing%20demonstration&width=600&height=400&seq=adanahijyen1&orientation=landscape',
    author: 'Dr. Ayşe Yılmaz',
    date: '23 Ocak 2025',
    readTime: '7 dk'
  },
  {
    id: 4,
    slug: 'adana-insaat-sektorunde-yuksekte-calisma',
    category: 'İş Güvenliği',
    title: 'Adana İnşaat Sektöründe Yüksekte Çalışma Güvenliği ve Eğitimi',
    excerpt: 'Adana inşaat sektöründe yüksekte çalışma riskleri, iskele güvenliği, kişisel koruyucu donanım kullanımı ve düşme önleme sistemleri.',
    content: 'Adana inşaat sektöründe yüksekte çalışma eğitimi, iş kazalarının önlenmesi için kritik öneme sahiptir. Adana Seyhan, Çukurova ve Yüreğir ilçelerindeki inşaat firmalarına özel yüksekte çalışma güvenliği eğitimi veriyoruz.',
    image: 'https://readdy.ai/api/search-image?query=Construction%20workers%20in%20Adana%20Turkey%20receiving%20height%20safety%20training%20on%20building%20site%20wearing%20safety%20harnesses%20and%20helmets%20professional%20instructor%20demonstrating%20fall%20arrest%20systems%20urban%20construction%20environment&width=600&height=400&seq=adanainsaat1&orientation=landscape',
    author: 'Ali Demir',
    date: '22 Ocak 2025',
    readTime: '8 dk'
  },
  {
    id: 5,
    slug: 'adanada-mesleki-egitim-merkezleri',
    category: 'MYK',
    title: 'Adana\'da Mesleki Eğitim Merkezleri ve Sertifika Programları 2025',
    excerpt: 'Adana\'da mesleki eğitim veren kurumlar, sertifikalı meslek edindirme kursları, işsizlik maaşı ile eğitim fırsatları ve kariyer geliştirme programları.',
    content: 'Adana mesleki eğitim merkezleri, işsizlik maaşı alanlar için ücretsiz meslek edindirme kursları sunmaktadır. Adana İŞKUR mesleki eğitim programları ile forklift, vinç, iş makinesi operatörlüğü ve diğer mesleki yeterlilik eğitimleri alabilirsiniz.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20vocational%20training%20center%20in%20Adana%20Turkey%20with%20diverse%20students%20learning%20technical%20skills%20professional%20workshop%20environment%20with%20industrial%20equipment%20and%20certification%20programs%20bright%20educational%20facility&width=600&height=400&seq=adanamesleki1&orientation=landscape',
    author: 'Mehmet Kaya',
    date: '21 Ocak 2025',
    readTime: '9 dk'
  },
  {
    id: 6,
    slug: 'adana-restoran-hijyen-egitimi',
    category: 'Hijyen',
    title: 'Adana Restoran ve Otel Personeli İçin Hijyen Eğitimi',
    excerpt: 'Adana\'da restoran, otel, kafe ve gıda işletmeleri için zorunlu hijyen eğitimi, gıda güvenliği sertifikası ve personel eğitim programları.',
    content: 'Adana restoran hijyen eğitimi, turizm ve gıda sektöründe faaliyet gösteren tüm işletmeler için zorunludur. Adana Seyhan, Çukurova ve Yüreğir ilçelerindeki otel, restoran ve kafe işletmelerine özel hijyen eğitimi paketleri sunuyoruz.',
    image: 'https://readdy.ai/api/search-image?query=Restaurant%20staff%20hygiene%20training%20in%20Adana%20Turkey%20with%20waiters%20and%20chefs%20learning%20food%20safety%20protocols%20modern%20dining%20establishment%20professional%20instructor%20demonstrating%20proper%20sanitation%20clean%20bright%20environment&width=600&height=400&seq=adanarestoran1&orientation=landscape',
    author: 'Dr. Ayşe Yılmaz',
    date: '20 Ocak 2025',
    readTime: '6 dk'
  },
  {
    id: 7,
    slug: 'adanada-ilkyardim-egitimi-nerede-alinir',
    category: 'İlkyardım',
    title: 'Adana\'da İlkyardım Eğitimi Nerede Alınır? 2025 Rehberi',
    excerpt: 'Adana Seyhan, Çukurova, Yüreğir ve Sarıçam ilçelerinde sertifikalı ilkyardım eğitimi alabileceğiniz merkez ve eğitim programları hakkında detaylı bilgiler.',
    content: 'Adana\'da ilkyardım eğitimi almak isteyen bireyler ve kurumlar için Sağlık Bakanlığı onaylı eğitim merkezimiz, Seyhan merkez lokasyonunda hizmet vermektedir. Adana ilkyardım kursu, Çukurova, Yüreğir, Sarıçam, Ceyhan ve Kozan ilçelerinden kolayca ulaşılabilir konumdadır.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20first%20aid%20training%20center%20in%20Adana%20Turkey%20with%20professional%20medical%20instructors%20teaching%20CPR%20and%20emergency%20response%20to%20diverse%20group%20of%20students%20bright%20classroom%20with%20Adana%20city%20landmarks%20visible%20through%20windows&width=600&height=400&seq=adanablog1&orientation=landscape',
    author: 'Dr. Ayşe Yılmaz',
    date: '20 Ocak 2025',
    readTime: '8 dk'
  },
  {
    id: 8,
    slug: 'adana-ilkyardim-sertifikasi-nasil-alinir',
    category: 'İlkyardım',
    title: 'Adana İlkyardım Sertifikası Nasıl Alınır? 2025 Güncel Bilgiler',
    excerpt: 'Adana\'da sertifikalı ilkyardım eğitimi alma süreci, gerekli belgeler, eğitim süresi ve MEB onaylı sertifika alma koşulları hakkında kapsamlı rehber.',
    content: 'Adana ilkyardım sertifikası almak için Sağlık Bakanlığı ve MEB onaylı eğitim merkezimizde 16 saatlik uygulamalı eğitim programına katılmanız gerekmektedir. Adana Seyhan merkezimizde verilen ilkyardım kursu sonunda geçerli sertifika alabilirsiniz.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20first%20aid%20certification%20ceremony%20in%20Adana%20with%20students%20receiving%20official%20certificates%20from%20instructors%20modern%20training%20facility%20with%20Turkish%20flag%20and%20medical%20equipment%20clean%20bright%20environment&width=600&height=400&seq=adanablog2&orientation=landscape',
    author: 'Mehmet Kaya',
    date: '18 Ocak 2025',
    readTime: '7 dk'
  },
  {
    id: 9,
    slug: 'adanada-is-guvenligi-egitimi-veren-kurumlar',
    category: 'İş Güvenliği',
    title: 'Adana\'da İş Güvenliği Eğitimi Veren Kurumlar ve Programlar',
    excerpt: 'Adana OSB, Hacı Sabancı OSB ve sanayi bölgelerinde faaliyet gösteren firmalar için iş güvenliği eğitimi veren kurumlar ve eğitim içerikleri.',
    content: 'Adana iş güvenliği eğitimi, 6331 sayılı İş Sağlığı ve Güvenliği Kanunu kapsamında zorunlu eğitimlerdir. Adana Organize Sanayi Bölgesi, Hacı Sabancı OSB ve çevre ilçelerdeki fabrikalara kurumsal iş güvenliği eğitimi hizmeti sunuyoruz.',
    image: 'https://readdy.ai/api/search-image?query=Industrial%20workplace%20safety%20training%20in%20Adana%20organized%20industrial%20zone%20with%20workers%20wearing%20safety%20equipment%20and%20helmets%20professional%20instructor%20demonstrating%20safety%20procedures%20factory%20environment&width=600&height=400&seq=adanablog3&orientation=landscape',
    author: 'Ali Demir',
    date: '16 Ocak 2025',
    readTime: '9 dk'
  },
  {
    id: 10,
    slug: 'adanada-yangin-sondurme-egitimi-acil-durum',
    category: 'Acil Durum',
    title: 'Adana\'da Yangın Söndürme Eğitimi ve Acil Durum Tatbikatı',
    excerpt: 'Adana\'da yangın güvenliği eğitimi, yangın söndürme cihazı kullanımı ve acil durum tahliye tatbikatı hakkında bilmeniz gereken her şey.',
    content: 'Adana yangın eğitimi programımız, iş yerlerinde yangın riskini azaltmak ve acil durumlarda doğru müdahale etmek için tasarlanmıştır. Adana Seyhan, Çukurova ve Yüreğir ilçelerindeki firmalara yerinde yangın tatbikatı hizmeti sunuyoruz.',
    image: 'https://readdy.ai/api/search-image?query=Fire%20safety%20training%20and%20extinguisher%20demonstration%20in%20Adana%20Turkey%20with%20professional%20instructor%20showing%20proper%20fire%20fighting%20techniques%20to%20workers%20controlled%20fire%20simulation%20orange%20flames%20industrial%20setting&width=600&height=400&seq=adanablog4&orientation=landscape',
    author: 'Mehmet Kaya',
    date: '14 Ocak 2025',
    readTime: '6 dk'
  },
  {
    id: 11,
    slug: 'adana-osb-zorunlu-ilkyardim-egitimi',
    category: 'İş Güvenliği',
    title: 'Adana OSB ve Sanayi Bölgelerinde Zorunlu İlkyardım Eğitimi',
    excerpt: 'Adana Organize Sanayi Bölgesi, Hacı Sabancı OSB ve diğer sanayi bölgelerinde faaliyet gösteren firmalar için zorunlu ilkyardım eğitimi gereklilikleri.',
    content: 'Adana OSB ilkyardım eğitimi, organize sanayi bölgelerinde faaliyet gösteren tüm firmalar için yasal zorunluluktur. Adana Organize Sanayi Bölgesi, Hacı Sabancı OSB, Ceyhan ve Kozan sanayi bölgelerindeki firmalara özel kurumsal eğitim paketleri sunuyoruz.',
    image: 'https://readdy.ai/api/search-image?query=Corporate%20first%20aid%20training%20in%20Adana%20organized%20industrial%20zone%20with%20factory%20workers%20learning%20emergency%20response%20professional%20training%20room%20with%20industrial%20background%20modern%20facility&width=600&height=400&seq=adanablog5&orientation=landscape',
    author: 'Dr. Ayşe Yılmaz',
    date: '12 Ocak 2025',
    readTime: '8 dk'
  },
  {
    id: 12,
    slug: 'adanada-myk-belgesi-nasil-alinir',
    category: 'MYK',
    title: 'Adana\'da MYK Belgesi Nasıl Alınır? Forklift ve İş Makinesi Eğitimi',
    excerpt: 'Adana\'da MYK belgesi alma süreci, forklift operatörlüğü, iş makinesi operatörlüğü ve diğer mesleki yeterlilik belgeleri hakkında detaylı bilgiler.',
    content: 'Adana MYK belgesi almak için Mesleki Yeterlilik Kurumu onaylı eğitim merkezimizde forklift, vinç, iş makinesi operatörlüğü eğitimleri verilmektedir. Adana Seyhan, Sarıçam ve Ceyhan ilçelerinden kolayca ulaşabilirsiniz.',
    image: 'https://readdy.ai/api/search-image?query=Forklift%20and%20heavy%20machinery%20operator%20training%20in%20Adana%20Turkey%20with%20professional%20instructor%20teaching%20equipment%20operation%20modern%20training%20facility%20with%20industrial%20vehicles%20certification%20program&width=600&height=400&seq=adanablog6&orientation=landscape',
    author: 'Ali Demir',
    date: '10 Ocak 2025',
    readTime: '7 dk'
  },
  {
    id: 13,
    slug: 'ilkyardim-nedir-temel-bilgiler',
    category: 'İlkyardım',
    title: 'İlkyardım Nedir? Temel Bilgiler ve Önemi',
    excerpt: 'İlkyardım, ani hastalık veya kaza durumlarında, sağlık ekipleri gelene kadar yapılan ilk müdahale uygulamalarıdır.',
    content: 'İlkyardım, herhangi bir kaza veya yaşamı tehlikeye düşüren durumda, sağlık görevlileri gelene kadar hayatın kurtarılması ya da durumun kötüleşmesini önlemek amacıyla yapılan ilk yardım uygulamalarıdır.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20first%20aid%20training%20scene%20with%20medical%20instructor%20demonstrating%20emergency%20response%20techniques%20on%20mannequin%20in%20modern%20bright%20classroom%20with%20medical%20equipment%20and%20first%20aid%20supplies%20clean%20environment&width=600&height=400&seq=blog1&orientation=landscape',
    author: 'Dr. Ayşe Yılmaz',
    date: '15 Ocak 2025',
    readTime: '5 dk'
  },
  {
    id: 14,
    slug: 'is-yerinde-ilkyardim-zorunlulugu',
    category: 'İş Güvenliği',
    title: 'İş Yerinde İlkyardım Zorunluluğu ve Yasal Düzenlemeler',
    excerpt: '6331 sayılı İş Sağlığı ve Güvenliği Kanunu kapsamında iş yerlerinde ilkyardımcı bulundurma zorunluluğu hakkında bilmeniz gerekenler.',
    content: 'İş Sağlığı ve Güvenliği Kanunu, tüm işyerlerinde belirli sayıda ilkyardımcı bulundurulmasını zorunlu kılmaktadır. Bu zorunluluk, çalışan sayısına ve işyerinin tehlike sınıfına göre değişmektedir.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20office%20workplace%20safety%20training%20with%20employees%20learning%20first%20aid%20procedures%20professional%20corporate%20environment%20with%20safety%20equipment%20and%20emergency%20response%20materials%20bright%20clean%20setting&width=600&height=400&seq=blog2&orientation=landscape',
    author: 'Mehmet Kaya',
    date: '12 Ocak 2025',
    readTime: '7 dk'
  },
  {
    id: 15,
    slug: 'kalp-masaji-nasil-yapilir',
    category: 'İlkyardım',
    title: 'Kalp Masajı (CPR) Nasıl Yapılır? Adım Adım Rehber',
    excerpt: 'Kalp durması anında hayat kurtaran CPR tekniğini doğru şekilde uygulamak için bilmeniz gereken tüm adımlar.',
    content: 'Kardiyopulmoner resüsitasyon (CPR), kalp durması yaşayan bir kişiye yapılan hayat kurtarıcı bir müdahale uygulamalarıdır.',
    image: 'https://readdy.ai/api/search-image?query=CPR%20cardiopulmonary%20resuscitation%20training%20demonstration%20with%20instructor%20showing%20proper%20chest%20compression%20technique%20on%20training%20mannequin%20in%20professional%20medical%20training%20facility%20bright%20lighting&width=600&height=400&seq=blog3&orientation=landscape',
    author: 'Dr. Ayşe Yılmaz',
    date: '10 Ocak 2025',
    readTime: '6 dk'
  },
  {
    id: 16,
    slug: 'yangin-guvenligi-ipuclari',
    category: 'Acil Durum',
    title: 'İş Yerinde Yangın Güvenliği: 10 Kritik İpucu',
    excerpt: 'İş yerinde yangın riskini azaltmak ve acil durumlarda doğru müdahale etmek için uygulamanız gereken güvenlik önlemleri.',
    content: 'Yangın güvenliği, iş yerlerinde en önemli konulardan biridir. Doğru önlemler alınmadığında can ve mal kayıplarına yol açabilecek yangınlar, basit tedbirlerle önlenebilir.',
    image: 'https://readdy.ai/api/search-image?query=Fire%20safety%20training%20in%20workplace%20with%20fire%20extinguisher%20demonstration%20and%20safety%20equipment%20professional%20training%20environment%20with%20controlled%20fire%20simulation%20orange%20flames%20dramatic%20lighting&width=600&height=400&seq=blog4&orientation=landscape',
    author: 'Ali Demir',
    date: '8 Ocak 2025',
    readTime: '8 dk'
  },
  {
    id: 17,
    slug: 'myk-belgesi-nedir',
    category: 'MYK',
    title: 'MYK Belgesi Nedir? Kimler Almalı?',
    excerpt: 'Mesleki Yeterlilik Kurumu (MYK) belgesi hakkında merak edilen tüm sorular ve belge alma süreci.',
    content: 'MYK belgesi, Mesleki Yeterlilik Kurumu tarafından verilen ve kişinin belirli bir meslekte yetkin olduğunu gösteren resmi bir belgedir. Birçok sektörde zorunlu hale gelmiştir.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20vocational%20certification%20training%20center%20with%20industrial%20equipment%20and%20workers%20in%20safety%20gear%20learning%20technical%20skills%20modern%20training%20facility%20with%20certification%20programs&width=600&height=400&seq=blog5&orientation=landscape',
    author: 'Mehmet Kaya',
    date: '5 Ocak 2025',
    readTime: '5 dk'
  },
  {
    id: 18,
    slug: 'yuksekte-calisma-guvenligi',
    category: 'İş Güvenliği',
    title: 'Yüksekte Çalışma Güvenliği: Temel Kurallar',
    excerpt: 'Yüksekte çalışırken uyulması gereken güvenlik kuralları ve düşme riskini azaltmak için alınması gereken önlemler.',
    content: 'Yüksekte çalışma, iş kazalarının en sık yaşandığı alanlardan biridir. Doğru ekipman kullanımı ve güvenlik prosedürlerine uyum, hayati önem taşımaktadır.',
    image: 'https://readdy.ai/api/search-image?query=Industrial%20height%20safety%20training%20with%20workers%20wearing%20safety%20harnesses%20on%20scaffolding%20structure%20professional%20occupational%20safety%20scene%20with%20blue%20sky%20background%20construction%20environment&width=600&height=400&seq=blog6&orientation=landscape',
    author: 'Ali Demir',
    date: '3 Ocak 2025',
    readTime: '6 dk'
  }
];

const categories = ['Tümü', 'İlkyardım', 'İş Güvenliği', 'Acil Durum', 'MYK', 'Hijyen'];

export default function Blog() {
  const [activeCategory, setActiveCategory] = useState('Tümü');
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    document.body.style.overflow = 'auto';
    document.body.style.position = 'static';
    document.title = 'Adana İlkyardım Eğitimi Blog | Adana İş Güvenliği Kursu - Sertifikalı Eğitimler';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Adana ilkyardım eğitimi, Adana iş güvenliği kursu, Adana yangın eğitimi ve Adana MYK belgesi hakkında güncel bilgiler. Seyhan, Çukurova, Yüreğir, Sarıçam ilçelerinde sertifikalı eğitimler.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Adana ilkyardım kursu, Adana iş güvenliği eğitimi, Adana sertifikalı ilkyardım, Adana yangın eğitimi, Adana MYK belgesi, Adana hijyen eğitimi, Adana OSB eğitim');
    }
    
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const filteredPosts = activeCategory === 'Tümü' 
    ? blogPosts 
    : blogPosts.filter(post => post.category === activeCategory);

  return (
    <div className="min-h-screen bg-[#f8f9fa]">
      {/* Navigation */}
      <header>
        <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm' : 'bg-white shadow-sm'}`} aria-label="Ana navigasyon">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between py-6">
              <Link to="/">
                <img 
                  src="https://static.readdy.ai/image/69983b9b992309f9f345f22b715baa7c/6b24d68bdeb9b34d218f93fb0e94b90c.png" 
                  alt="Adana İlkyardım Eğitim Merkezi Logo" 
                  title="Adana İlkyardım Eğitim Merkezi"
                  className="h-40 w-auto object-contain"
                />
              </Link>
              <ul className="flex gap-8 list-none">
                <li><Link to="/" className="text-gray-700 text-sm font-medium uppercase tracking-wide hover:text-[#ecad29] transition-colors cursor-pointer">Ana Sayfa</Link></li>
                <li><Link to="/egitimler" className="text-gray-700 text-sm font-medium uppercase tracking-wide hover:text-[#ecad29] transition-colors cursor-pointer">Eğitimler</Link></li>
                <li><Link to="/blog" className="text-[#ecad29] text-sm font-medium uppercase tracking-wide relative pb-2 cursor-pointer after:content-[''] after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[3px] after:bg-[#ecad29] after:rounded">Blog</Link></li>
                <li><Link to="/iletisim" className="text-gray-700 text-sm font-medium uppercase tracking-wide hover:text-[#ecad29] transition-colors cursor-pointer">İletişim</Link></li>
              </ul>
            </div>
          </div>
        </nav>
      </header>

      <main>
        {/* Hero Section */}
        <section className="pt-48 pb-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#1a1a1a] to-[#2d2d2d]" aria-label="Blog başlık">
          <div className="max-w-7xl mx-auto text-center">
            <div className="inline-block px-4 py-2 bg-[#ecad29]/20 rounded-full mb-6">
              <span className="text-[#ecad29] text-sm font-medium">Adana İlkyardım ve İş Güvenliği Bilgi Merkezi</span>
            </div>
            <h1 className="text-4xl lg:text-5xl font-bold text-white mb-6 font-['Oswald']">
              ADANA İLKYARDIM EĞİTİMİ <span className="text-[#ecad29]">BLOG</span>
            </h1>
            <p className="text-gray-300 text-lg max-w-3xl mx-auto">
              <strong>Adana ilkyardım eğitimi</strong>, <strong>Adana iş güvenliği kursu</strong>, <strong>Adana yangın eğitimi</strong> ve <strong>Adana MYK belgesi</strong> hakkında güncel bilgiler. Seyhan, Çukurova, Yüreğir, Sarıçam, Ceyhan ve Kozan ilçelerinde sertifikalı eğitim programları.
            </p>
          </div>
        </section>

        {/* Filter Section */}
        <section className="py-8 px-4 sm:px-6 lg:px-8 bg-white border-b sticky top-28 z-40" aria-label="Blog kategorileri">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-wrap items-center gap-3" role="tablist">
              {categories.map((cat) => (
                <button
                  key={cat}
                  onClick={() => setActiveCategory(cat)}
                  className={`px-5 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                    activeCategory === cat
                      ? 'bg-[#ecad29] text-white shadow-lg shadow-[#ecad29]/30'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                  role="tab"
                  aria-selected={activeCategory === cat}
                >
                  {cat}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Blog Grid */}
        <section className="py-16 px-4 sm:px-6 lg:px-8" aria-label="Blog yazıları">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredPosts.map((post) => (
                <article 
                  key={post.id}
                  className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl hover:-translate-y-2 transition-all duration-300 cursor-pointer group"
                >
                  <div className="relative h-[220px] w-full overflow-hidden">
                    <img 
                      src={post.image}
                      alt={`${post.title} - Adana İlkyardım Blog`}
                      title={post.title}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                    <span className="absolute top-4 right-4 px-3 py-1 bg-[#ecad29] text-white text-xs font-medium rounded-full">
                      {post.category}
                    </span>
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-4 text-xs text-gray-500 mb-3">
                      <span className="flex items-center gap-1">
                        <i className="ri-calendar-line w-4 h-4 flex items-center justify-center"></i>
                        {post.date}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-time-line w-4 h-4 flex items-center justify-center"></i>
                        {post.readTime} okuma
                      </span>
                    </div>
                    <h2 className="text-lg font-bold text-gray-900 mb-3 line-clamp-2 group-hover:text-[#ecad29] transition-colors">
                      <a href={`/blog/${post.slug}`}>{post.title}</a>
                    </h2>
                    <p className="text-gray-600 text-sm mb-4 line-clamp-3">{post.excerpt}</p>
                    
                    <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                      <div className="flex items-center gap-2">
                        <div className="w-8 h-8 bg-[#ecad29]/10 rounded-full flex items-center justify-center">
                          <i className="ri-user-line text-[#ecad29] text-sm"></i>
                        </div>
                        <span className="text-xs text-gray-600">{post.author}</span>
                      </div>
                      <a 
                        href={`/blog/${post.slug}`}
                        className="text-[#ecad29] text-sm font-medium flex items-center gap-1 hover:gap-2 transition-all cursor-pointer"
                      >
                        Devamını Oku
                        <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                      </a>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* SEO Content Section */}
        <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white" aria-label="Adana ilkyardım eğitimi hakkında">
          <div className="max-w-4xl mx-auto">
            <h3 className="text-3xl font-bold text-gray-900 mb-6 text-center font-['Oswald']">
              ADANA'DA İLKYARDIM VE <span className="text-[#ecad29]">İŞ GÜVENLİĞİ EĞİTİMİ</span>
            </h3>
            <div className="prose prose-lg max-w-none text-gray-700 space-y-4">
              <p>
                <strong>Adana ilkyardım kursu</strong> arayan bireyler ve kurumlar için kapsamlı eğitim programları sunuyoruz. <strong>Adana Seyhan</strong>, <strong>Çukurova</strong>, <strong>Yüreğir</strong>, <strong>Sarıçam</strong>, <strong>Ceyhan</strong> ve <strong>Kozan</strong> ilçelerinden kolayca ulaşabileceğiniz merkezimizde, Sağlık Bakanlığı ve MEB onaylı <strong>sertifikalı ilkyardım eğitimi</strong> verilmektedir.
              </p>
              <p>
                <strong>Adana iş güvenliği eğitimi</strong> kapsamında, <strong>Adana Organize Sanayi Bölgesi</strong>, <strong>Hacı Sabancı OSB</strong> ve diğer sanayi bölgelerinde faaliyet gösteren firmalara özel kurumsal eğitim paketleri sunuyoruz. 6331 sayılı İş Sağlığı ve Güvenliği Kanunu gereği zorunlu olan <strong>Adana ilkyardım eğitimi</strong>, çalışan güvenliği için kritik öneme sahiptir.
              </p>
              <p>
                <strong>Adana yüksekte çalışma eğitimi</strong>, inşaat ve sanayi sektörlerinde çalışan personel için hayati önem taşımaktadır. <strong>Adana'da yüksekte çalışma kursu</strong> veren merkezimiz, düşme önleme teknikleri, kişisel koruyucu donanım kullanımı ve güvenlik prosedürleri konusunda kapsamlı eğitimler vermektedir. İskele güvenliği, emniyet kemeri kullanımı ve acil durum müdahale prosedürleri eğitimlerimizin temel konularıdır.
              </p>
              <p>
                <strong>Adana mesleki eğitim</strong> programlarımız, Mesleki Yeterlilik Kurumu (MYK) onaylı sertifika programlarını içermektedir. <strong>Adana'da mesleki eğitim</strong> almak isteyen forklift operatörleri, vinç operatörleri ve iş makinesi operatörleri için uygulamalı eğitim programlarımız mevcuttur. <strong>Adana MYK belgesi</strong> almak için gerekli tüm teorik ve pratik eğitimleri veriyoruz.
              </p>
              <p>
                <strong>Adana hijyen eğitimi</strong>, gıda sektöründe çalışan tüm personel için zorunlu bir eğitimdir. <strong>Adana'da hijyen kursu</strong> veren merkezimiz, Sağlık Bakanlığı onaylı gıda güvenliği eğitimi ve HACCP sertifikası programları sunmaktadır. Restoran, otel, kafe ve gıda üretim tesislerinde çalışan personel için <strong>Adana gıda hijyeni eğitimi</strong> veriyoruz. Kişisel hijyen, gıda güvenliği, bulaşıcı hastalıklar ve temizlik prosedürleri konularında kapsamlı eğitimler sunuyoruz.
              </p>
              <p>
                <strong>Adana yangın eğitimi</strong> ve acil durum tatbikatları, iş yerlerinde yangın riskini azaltmak ve acil durumlarda doğru müdahale etmek için tasarlanmıştır. Yangın söndürme cihazı kullanımı, tahliye prosedürleri ve acil durum yönetimi konularında uygulamalı eğitimler veriyoruz.
              </p>
              <p>
                Eğitim merkezimiz, <strong>Adana merkez</strong> lokasyonunda olup, tüm ilçelerden toplu taşıma ile kolayca ulaşılabilir durumdadır. Kurumsal firmalar için yerinde eğitim hizmeti de sunmaktayız. <strong>Adana sertifikalı ilkyardım</strong> eğitimi almak, <strong>yüksekte çalışma güvenliği</strong> konusunda uzmanlaşmak, <strong>mesleki yeterlilik belgesi</strong> almak veya <strong>hijyen sertifikası</strong> edinmek için bizimle iletişime geçebilirsiniz.
              </p>
            </div>
          </div>
        </section>

        {/* Newsletter Section */}
        <section className="py-16 px-4 sm:px-6 lg:px-8 bg-[#1a1a1a]" aria-label="Bülten aboneliği">
          <div className="max-w-2xl mx-auto text-center">
            <h4 className="text-3xl font-bold text-white mb-4 font-['Oswald']">
              GÜNCEL <span className="text-[#ecad29]">KALMAYIN</span>
            </h4>
            <p className="text-gray-400 mb-8">
              Adana ilkyardım eğitimi, iş güvenliği ve acil durum müdahalei hakkında en güncel bilgileri öğrenin.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/iletisim"
                className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-[#ecad29] text-white rounded-full font-medium hover:bg-[#d49a1f] transition-colors whitespace-nowrap cursor-pointer"
              >
                <span>Bize Ulaşın</span>
                <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
              </Link>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="py-8 px-4 sm:px-6 lg:px-8 bg-[#ecad29]/10">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-600 text-sm">© 2025 Adana İlkyardım Eğitim Merkezi. Tüm hakları saklıdır.</p>
          <nav aria-label="Footer navigasyon">
            <ul className="flex items-center gap-6 list-none">
              <li><Link to="/egitimler" className="text-gray-500 text-sm hover:text-[#ecad29] transition-colors">Eğitimler</Link></li>
              <li><Link to="/blog" className="text-gray-500 text-sm hover:text-[#ecad29] transition-colors">Blog</Link></li>
              <li><Link to="/iletisim" className="text-gray-500 text-sm hover:text-[#ecad29] transition-colors">İletişim</Link></li>
            </ul>
          </nav>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer nofollow"
            className="text-gray-500 text-xs hover:text-gray-700 transition-colors"
          >
            Powered by Readdy
          </a>
        </div>
      </footer>

      {/* Fixed Contact Icons */}
      <aside className="fixed bottom-6 left-6 z-[150] flex flex-col gap-3" aria-label="İletişim butonları">
        <a 
          href="https://wa.me/905324196401" 
          target="_blank" 
          rel="noopener noreferrer nofollow"
          className="w-12 h-12 flex items-center justify-center bg-[#25D366] text-white rounded-full hover:scale-110 hover:shadow-lg transition-all cursor-pointer"
          title="WhatsApp ile iletişime geçin"
          aria-label="WhatsApp"
        >
          <i className="ri-whatsapp-line text-xl"></i>
        </a>
        <a 
          href="mailto:info@assaakademi.com.tr" 
          className="w-12 h-12 flex items-center justify-center bg-[#ecad29] text-black rounded-full hover:scale-110 hover:shadow-lg transition-all cursor-pointer"
          title="E-posta gönderin"
          aria-label="E-posta"
        >
          <i className="ri-mail-line text-xl"></i>
        </a>
        <a 
          href="tel:08503462772" 
          className="w-12 h-12 flex items-center justify-center bg-white text-black rounded-full hover:scale-110 hover:shadow-lg transition-all cursor-pointer shadow-md"
          title="Bizi arayın: 0850 346 2772"
          aria-label="Telefon"
        >
          <i className="ri-phone-line text-xl"></i>
        </a>
      </aside>
    </div>
  );
}
